import React, { useEffect, useState, useRef } from "react"
import Chart from "react-apexcharts"
import { FaDownload } from "react-icons/fa"
import API from "../../api"
import ApexCharts from "apexcharts"
// eslint-disable-next-line react/prop-types
const StatsColumnChart = ({ width = "100%", height = 500 }) => {
  const chartRef = useRef(null)
  const [series, setSeries] = useState([])
  const [categories, setCategories] = useState([])
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  useEffect(() => {
    API.post("specialite/stat_etudiant",{annee_id})
      .then(res => {
        const data = res.data.statistiques
        setCategories(data.categories)
        setSeries(data.series)
      })
      .catch(err => {
        console.error("Erreur lors du chargement des statistiques :", err)
      })
  }, [])
  const options = {
    chart: {
      type: "bar",
      height: height,
      toolbar: {
        show: true,
        tools: {
          download: true,
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "45%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: categories.length ? categories : ["Chargement..."],
      labels: {
        rotate: -25,
        trim: false,
        hideOverlappingLabels: false,
        formatter: function (value) {
          if (!value) return ""
          const parts = value.split(" ")
          if (parts.length > 2) {
            return parts.slice(0, 2).join(" ") + "\n" + parts.slice(2).join(" ")
          }
          return value
        },
        style: {
          fontSize: "12px",
          colors: "#333",
          fontWeight: 500,
        },
      },
      tickPlacement: "on",
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: true,
        color: "#ddd",
      },
    },
    yaxis: {
      title: {
        text: "Nombre d'étudiants",
      },
    },
    fill: {
      opacity: 1,
    },
    colors: ["#008FFB", "#00E396", "#FEB019"],// couleurs des colonnes
    legend: {
      position: "top",
      horizontalAlign: "center",
      fontSize: "14px",
      fontWeight: 500,
      labels: {
        colors: "#333",
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val
        },
      },
    },
    grid: {
      padding: {
        bottom: 50 // espace pour les labels longs
      }
    }
  }
  const handleDownload = async () => {
    try {
      // utilisation d'ApexCharts.exec pour récupérer l'image (méthode la plus fiable)
      const { imgURI } = await ApexCharts.exec(chartId, "dataURI")
      if (!imgURI) {
        alert("Erreur : impossible de récupérer l'image du graphique.")
        return
      }
      const link = document.createElement("a")
      link.href = imgURI
      const today = new Date().toISOString().split("T")[0]
      link.download = `stat_etudiants_specialite_${today}.png`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (err) {
      console.error("Erreur téléchargement chart :", err)
      alert("Impossible de télécharger le graphique pour le moment.")
    }
  }
  return (
    <div style={{ textAlign: "center" }}>
      <h3 style={{ color: "#008ffb" }}>
        {"Statistique nombre d'étudiants par spécialité et niveau"}
      </h3>
      {/*<FaDownload*/}
      {/*  onClick={handleDownload}*/}
      {/*  style={{*/}
      {/*    cursor: "pointer",*/}
      {/*    marginBottom: "10px",*/}
      {/*    color: "#E91E63",*/}
      {/*    fontSize: "17px",*/}
      {/*  }}*/}
      {/*/>*/}
      <Chart
        ref={chartRef}
        options={options}
        series={series.length ? series : [{ name: "Chargement...", data: [] }]}
        type="bar"
        width={width}
        height={height}
      />
    </div>
  )
}

export default StatsColumnChart